import React, { useContext } from 'react';
import { useAppSelector } from '../../../../../redux/store.model';
import { SearchList } from '../SearchList/SearchList';
import { getAllBusinessUnits } from '../../../../../redux/structure/selectors/BusinessUnit.selector';
import { isLoadingStructure } from '../../../../../redux/structure/selectors/Structure.selector';
import { useParams } from 'react-router-dom';
import { SearchContext } from '../SearchBar';

export const BUSearch = () => {
  const { search } = useContext(SearchContext);
  const searchQuery = search.toLowerCase();
  const { marketId } = useParams<{ marketId: string }>();

  const businessUnits = useAppSelector((state) =>
    getAllBusinessUnits(state, { workspaceId: marketId })
  );
  const isLoading = useAppSelector((state) =>
    isLoadingStructure(state, { workspaceId: marketId })
  );

  const filteredBusinessUnits =
    businessUnits
      ?.filter((businessUnit) =>
        businessUnit.name.toLowerCase().includes(searchQuery)
      )
      .map((item) => {
        return { ...item, key: item.id ?? '', value: item.name ?? '' };
      }) ?? [];

  return (
    <SearchList
      header="search.business_unit"
      list={filteredBusinessUnits}
      loading={isLoading}
    />
  );
};
